var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": require("images/logo-sub.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_vm._v("网易公司版权所有 ©1997-2017　粤网文[2014]0636-236号")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e2ea6e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/footer.vue
// module id = null
// module chunks = 